import { render, staticRenderFns } from "./SocialLink.vue?vue&type=template&id=bcff6b16&scoped=true&"
import script from "./SocialLink.vue?vue&type=script&lang=js&"
export * from "./SocialLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcff6b16",
  null
  
)

export default component.exports